module.exports = __webpack_public_path__ + "static/media/Bnner_Data_Implementacao_de_Microservices.54180d43.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banners/courses/Bnner_Data_Implementacao_de_Microservices.png
// module id = 237
// module chunks = 0